const hostname = window && window.location && window.location.hostname.toLowerCase();

export function getFeatureToggleVariable() {
  const featureProviderVariables = {};
  featureProviderVariables.REDIRECT_URI = window.location.href
    .slice(0, -window.location.hash.length || window.location.href.length)
    .slice(0, -window.location.search.length || window.location.href.length);

  featureProviderVariables.PAGE_LIMIT = 100;

  featureProviderVariables.RECORDS_PER_PAGE = 25;
  featureProviderVariables.POLICY_BENEFIT = true;

  if (hostname.includes('myaccess.standard') || hostname.includes('myaccess.standard.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'PROD';
  } else if (hostname.includes('preprod.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'PRE-PROD';
  } else if (hostname.includes('staging.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'STAGING';
  } else if (hostname.includes('uat.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'UAT';
  } else if (hostname.includes('int.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'INT';
  } else if (hostname.includes('dev.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'DEV';
  } else if (hostname.includes('int2.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'INT2';
  } else if (hostname.includes('dev2.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'DEV2';
  } else if (hostname.includes('dev3.allstate.com')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'DEV3';
  } else if (hostname.includes('localhost')) {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'LOCAL';
  } else {
    featureProviderVariables.FOOTER_OPEN_DEFAULT = true;
    featureProviderVariables.ENV = 'INT';
  }
  return featureProviderVariables;
}
